import React from 'react';
import {observer} from 'mobx-react';
import {useStores} from '../../Hooks';
import {Dialog, Button, Box, Typography} from '@mui/material';
import WarningIcon from '@mui/icons-material/WarningAmberRounded';

const RecordingWarningModal = observer(() => {
    const {modalStore} = useStores();

    const handleClose = () => {
        modalStore.isRecordingWarningModalOpen = false;
    };

    return (
        <Dialog
            open={modalStore.isRecordingWarningModalOpen}
            onClose={handleClose}
            PaperProps={{
                sx: {
                    borderRadius: 'var(--menus-radius)',
                    padding: '15px',
                    margin: 0,
                    backgroundColor: 'var(--windowsandmenus-normal-color)',
                    width: '432px',
                    maxWidth: '100%',
                }
            }}
            data-testId={'recording-warning-modal'}
        >
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '25px',
            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                    <WarningIcon
                        sx={{
                            color: 'var(--leavedeletenew-normal-color)',
                            fontSize: 30,
                            marginBottom: '5px'
                        }}
                    />
                    <Typography sx={{
                        fontFamily: 'Open Sans',
                        fontWeight: 700,
                        fontSize: '24px',
                        letterSpacing: "0",
                        lineHeight: "normal",
                        color: 'var(--main-normal-color)',
                        textAlign: 'center',
                    }}>
                        Warning
                    </Typography>
                </Box>

                <Typography sx={{
                    fontFamily: 'Open Sans',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: 'normal',
                    letterSpacing: '0',
                    color: 'var(--main-normal-color)',
                    textAlign: 'center',
                }}>
                    Recording has stopped due to a server error. Please try reactivating the recorder. If the problem
                    persists you can contact us.
                </Typography>

                <Button
                    onClick={handleClose}
                    variant="contained"
                    sx={{
                        backgroundColor: 'var(--leavedeletenew-normal-color)',
                        '&:hover': {
                            backgroundColor: 'var(--classicbutton-normal-color)',
                        },
                        borderRadius: 'var(--buttons-radius)',
                        paddingX: 1.5,
                        paddingY: 1,
                        minWidth: 41,
                        fontSize: '12px',
                    }}
                >
                    OK
                </Button>
            </Box>
        </Dialog>
    );
});

export default RecordingWarningModal;